const form12 = {
  formId12: "new-user-form12",
  formField12: {
    provisionLevel: {
      name: "provisionLevel",
      label: "[04] Mức trích lập (%):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mức trích lập",
    },
    amountSetAside: {
      name: "amountSetAside",
      label: "[05] Số tiền trích lập (đồng Việt Nam):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số tiền trích lập",
    },
  },
};

export default form12;
